import Notification from "../../components/Dashboard.js/Notification";
import AdminLayout from "../../layout/AdminLayout";

const QR = () =>{
    return(
        <AdminLayout>
        <div>
            <Notification/>
        </div>
        </AdminLayout>
    );
}
export default QR;
